import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {NotificationModel} from '../../api/models/notification-model';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmHtmlDialogData, MatConfirmHtmlDialogComponent} from '../../dialogs/mat-confirm-html/mat-confirm-html-dialog.component';
import {NotificationSettingsModel} from '../../api/models/notification-settings-model';
import {LocalNotificationsService} from '../../core/services/local-notifications.service';
import { MatIconAnchor, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { HumanizedDurationPipe } from '../../core/pipes/humanized-duration.pipe';

@Component({
    selector: 'app-new-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: true,
    imports: [MatIconAnchor, MatTooltip, MatMenuTrigger, NgIf, MatIcon, MatMenu, MatMenuItem, MatButton, NgFor, FlexModule, PhoneNumberPipe, HumanizedDurationPipe]
})
export class NotificationsComponent implements OnInit, OnDestroy {

  public showProgress = false;
  public show = false;
  public notifications: NotificationModel[] = [];
  @ViewChild('notificationsMenuAnchor', {static: true}) public notificationsMenuAnchor: ElementRef;
  @ViewChild('notificationsMenuPopup', {read: ElementRef}) public notificationsMenuPopup: ElementRef;
  private notificationsSubscription: Subscription;

  constructor(public headerService: HeaderService,
              private router: Router,
              public dialog: MatDialog,
              public notificationsService: LocalNotificationsService) {

  }

  public onRowClick(event, dataItem: NotificationModel) {
    if (dataItem.url) {
      if (dataItem.eventType === 'export') {
        const a = document.createElement('a');
        a.style.display = 'none';
        document.body.appendChild(a);

        a.href = dataItem.url;
        a.target = '_blank';
        a.click();
      } else {
        this.router.navigateByUrl(dataItem.url.replace('+', '%2B'));
      }
    }
  }

  async clearAllNotifications() {
    await this.notificationsService.markAllUnreadNotifications();
  }

  ngOnInit() {
    this.notificationsSubscription = this.notificationsService.latestNotifications.subscribe((data) => {
      this.showProgress = false;
      if (data) {
        this.notifications = data.filter(x => x.eventType !== 'dialog');
      } else {
        this.notifications = [];
      }

      // check for dialog notifications
      const dialogNotifications = data.filter(x => x.eventType === 'dialog');
      for (const dialogNotification of dialogNotifications) {
        console.log(dialogNotification);
        const notificationSettings: NotificationSettingsModel = dialogNotification.settings || {
          title: 'Notification',
          hideCancel: true,
          dialogWidth: undefined,
          actionTitle: 'Got It'
        };
        const dialogRef = this.dialog.open<MatConfirmHtmlDialogComponent, ConfirmHtmlDialogData>(MatConfirmHtmlDialogComponent, {
          width: notificationSettings.dialogWidth,
          data: {
            title: notificationSettings.title,
            html: dialogNotification.messageText,
            actionTitle: notificationSettings.actionTitle,
            hideCancel: notificationSettings.hideCancel
          }
        });

        dialogRef.afterClosed().subscribe(async (result) => {
          if (result) {
            await this.notificationsService.markUnreadNotifications(0, dialogNotification.nKey);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.notificationsSubscription) {
      this.notificationsSubscription?.unsubscribe();
    }
  }
}
